module.exports = __webpack_public_path__ + "static/alice_k106-afe5b24f2594ba6d0c6f0d2f7190e9e4.jpg";